import { createMuiTheme } from "@material-ui/core/styles"

const primary = "#ac1388"
const secondary = "#f79d4a"

export default createMuiTheme({
  palette: {
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    }
  },
  typography: {
    useNextVariants: true,
    fontSize: 16
  },
  overrides: {}
})



// WEBPACK FOOTER //
// ./src/themes/main.js